import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-bootstrap-date-picker';
import TeamTrainingMatterLineScheduleInstructorModal from './TeamTrainingMatterLineScheduleInstructorModal';


class TeamTrainingMatterLine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      team_id: null,
      modal: false,
      file: false,
      date_start: null,
      date_finish: null,
      lista_instrutores: [],
      dificuldades: [],
      setting_level_id: null,
      presence: null,
      moodle_group_id: null,
      exam_start: null,
      materia: {},
      matter_moodle_ids: [],
      matter_moodle_id: '',
    };
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.handleChangeDateFinishPicker = this.handleChangeDateFinishPicker.bind(this);
    this.editarMateria = this.editarMateria.bind(this);
    this.export = this.export.bind(this);
    this.exportRPA = this.exportRPA.bind(this);
    this.exportPresenceList = this.exportPresenceList.bind(this);
    this.getNow = this.getNow.bind(this);
    this.confirmarProva = this.confirmarProva.bind(this);
    this.generateLink = this.generateLink.bind(this);
    this.exportMoodle = this.exportMoodle.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }

  handleChangeDateFinishPicker(value, formattedValue) {
    this.setState({
      date_finish: value,
      date_finish_str: formattedValue,
    });
  }

  handleSelectChangeInstrutor(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change, ()=> {
      this.adicionarInstrutor();
    });
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.materia.id !== 'undefined' && this.state.loaded === 0) {
      this.setState({
        materia: newProps.materia,
        team_id: newProps.materia.team_id,
        setting_level_id: newProps.materia.setting_level_id,
        presence: newProps.materia.presence,
        moodle_group_id: newProps.materia.moodle_group_id,
        date_start: newProps.materia.date_start,
        date_finish: newProps.materia.date_finish,
        exam_start: newProps.materia.exam_start_str,
        avaliation: newProps.materia.avaliation,
        matter_moodle_id: newProps.materia.matter_moodle_id,
        loaded: 1
      });
    }

    if(Array.isArray(newProps.materia.staff_matter)) {
      this.setState({lista_instrutores: newProps.materia.staff_matter});
    }

    if(Array.isArray(newProps.dificuldades)) {
      this.setState({dificuldades: newProps.dificuldades});
    }

    if(newProps.matter_moodle_ids && Object.keys(newProps.matter_moodle_ids).length > 0) {
      this.setState({matter_moodle_ids: newProps.matter_moodle_ids[newProps.materia.id] || []});
    } else {
      this.setState({matter_moodle_ids: []});
    }
  }

  // Fetch salvando a edição
  generateLink(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      team_training_matter_id: this.props.materia.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/link', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          // navigator.clipboard.writeText(responseJson.data.url);
          self.props.refreshData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportMoodle(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      team_training_matter_id: this.props.materia.id,
      matter_moodle_id: this.state.matter_moodle_id,
      type: 'single',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/enviar/moodle', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({loaded: 0});
          self.props.refreshData(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.props.errorsMoodle(responseJson.data);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  getNow() {
    var currentdate = new Date();
    var datetime = ("0" + currentdate.getDate()).slice(-2) + "/"
                    + ("0" + (currentdate.getMonth()+1)).slice(-2)  + "/"
                    + currentdate.getFullYear() + " "
                    + currentdate.toLocaleTimeString('en-GB', { hour: "numeric", minute: "numeric"})
                    + ':00';
    return datetime;
  }

  // Fetch salvando a edição
  confirmarProva(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      team_training_matter_id: this.props.materia.id,
      team_id: this.props.materia.team_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/confirmar_provas_materia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  editarMateria(event) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.props.materia.id,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      exam_start: this.state.exam_start,
      setting_level_id: this.state.setting_level_id,
      presence: this.state.presence,
      matter_moodle_id: this.state.matter_moodle_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  export(event) {
    this.props.handleAlert('', '', 'open');
    var team_training_matter_id = event.currentTarget.value;
    var url = "/exportar/avaliacao/treinamento/materia/" + team_training_matter_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.props.handleAlert('', '', 'closed');
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  exportRPA(event) {
    this.props.handleAlert('', '', 'open');
    var team_training_matter_id = event.currentTarget.value;
    var url = "/exportar/rpa/materia/" + team_training_matter_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.props.handleAlert('', '', 'closed');
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  exportPresenceList(event) {
    this.props.handleAlert('', '', 'open');
    var team_training_matter_id = event.currentTarget.value;
    var url = "/exportar/listagem/presenca/materia/" + team_training_matter_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.props.handleAlert('', '', 'closed');
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  render() {
    var self = this;
    if (typeof this.props.materia.matter !== 'undefined') {
      return (
          <tr>
            <td className="text-center">
              <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
              {self.props.materia.matter.name} ({self.props.materia.matter.hours_time})
            </td>
            <td className="text-center">
              <TeamTrainingMatterLineScheduleInstructorModal refreshData={self.props.refreshData} RequestApi={self.refs.request_api} handleAlert={self.props.handleAlert} team_training_matter_id={self.props.materia.id} materia={this.props.materia} lista_instrutores={self.props.lista_instrutores}/></td>
            <td className="text-center">
              {
                <Select
                  className="small-font-input"
                  name="presence"
                  value={this.state.presence}
                  searchable={true}
                  placeholder={'Selecione o tipo de presença'}
                  onChange={this.handleSelectChange.bind(this, 'presence')}
                  options={[
                    {value: "presencial", label: "Presencial"},
                    {value: "ead", label: "EAD"},
                    {value: "semipresencial", label: "Semipresencial"},
                  ]}
                />
              }
            </td>
            <td>
              <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de início" value={this.state.date_start} />
            </td>
            <td>
              <DatePicker onChange={this.handleChangeDateFinishPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de término" value={this.state.date_finish} />
            </td>
            <td className="text-center">
              {
                (this.state.avaliation === 1) &&
                  <div className="input-group">
                    <InputMask value={this.state.exam_start}  maskChar={null} name="exam_start" mask="99/99/9999  99:99:99" className="form-control small-font-input" onChange={this.handleChange.bind(this, 'exam_start')} placeholder="dd/mm/yyyy hh:mm:ss"/>
                    <div className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_start: this.getNow()})}><i className="fa fa-calendar"></i></div>
                  </div>
              }
            </td>
            <td className="text-center">
              {
                (this.state.avaliation === 1) &&
                  <Select
                    className="small-font-input"
                    name="setting_level_id"
                    value={this.state.setting_level_id}
                    searchable={true}
                    placeholder={'Dificuldade'}
                    onChange={this.handleSelectChange.bind(this, 'setting_level_id')}
                    options={this.state.dificuldades}
                  />
              }
            </td>
            <td className="text-center">
              {
                (this.state.presence === 'ead') &&
                  <Select
                    className="small-font-input"
                    name="matter_moodle_id"
                    value={this.state.matter_moodle_id}
                    searchable={true}
                    placeholder={'Moodle ID'}
                    onChange={this.handleSelectChange.bind(this, 'matter_moodle_id')}
                    options={this.state.matter_moodle_ids}
                  />
              }
            </td>
            <td className="text-center">
              {
                (this.state.presence === 'ead' && this.state.moodle_group_id) ?
                  <span className="label label-success">
                    {this.state.moodle_group_id}
                  </span>
                  : (this.state.presence === 'ead') ?
                    <span className="label label-danger">Não integrado</span>
                  : ''
              }
            </td>
            <td className="text-center">
              <div className="btn-group">
                <button className="btn btn-primary btn-xs" onClick={this.editarMateria}><i className="fa fa-fw fa-floppy-o"></i></button>
                <button type="button" className="btn btn-success btn-xs" onClick={() => this.props.openCsvModal(this.props.materia.id)}><i className="fa fa-fw fa-file-excel-o"></i></button>
                <button className="btn btn-info btn-xs" value={this.props.materia.id} onClick={this.exportPresenceList}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                <button className="btn btn-warning btn-xs" value={this.props.materia.id} onClick={this.confirmarProva}><i className="fa fa-fw fa-plus"></i>Lançar provas</button>
                <button className="btn btn-info btn-xs" value={this.props.materia.id} onClick={this.generateLink}><i className="fa fa-link"></i> Gerar link</button>
                <button className="btn btn-danger btn-xs" value={this.props.materia.id} onClick={this.exportMoodle}><i className="fa fa-download"></i> Moodle</button>
              </div>
            </td>
          </tr>
      );
    } else {
      return(
        <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
      );
    }
  }
}

export default TeamTrainingMatterLine;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamTrainingMatterLine.js